export default __webpack_public_path__ + "static/media/grail.54d19f28.png";